import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const leaveSelectedTabState = atom({
  key: "leaveSelectedTabState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});
